import {ThemeProvider, Hero, Box, AnchorNav, RiverBreakout, Image, Text, Timeline, Link} from '@primer/react-brand'
import {PlayIcon} from '@primer/octicons-react'
import {Spacer} from './components/Spacer'

const extURLs = {
  get_started: '#pricing',
  how_gh_works: 'https://www.youtube.com/watch?v=w3jLJU7DT5E',
}

export function CodeReviewIndex() {
  return (
    <ThemeProvider colorMode="light" className="fp-hasFontSmoothing">
      {/* Header + Subnav = 136px */}
      <Spacer size="136px" />
      <Spacer size="48px" size1012="96px" />

      {/* Section Hero */}

      <section id="hero">
        <div className="fp-Section-container">
          <Hero data-hpc className="fp-Hero">
            <Hero.Label color="green">Code Review</Hero.Label>
            <Hero.Heading size="2">Write better code</Hero.Heading>
            <Hero.Description size="300">
              On GitHub, lightweight code review tools are built into every pull request. Your team can create review
              processes that improve the quality of your code and fit neatly into your workflow.
            </Hero.Description>
            <Hero.PrimaryAction href={extURLs.get_started}>Get started</Hero.PrimaryAction>
            <Hero.SecondaryAction href={extURLs.how_gh_works} trailingVisual={<PlayIcon />}>
              How GitHub works
            </Hero.SecondaryAction>
          </Hero>

          <Box className="fp-AnchorNav">
            <AnchorNav hideUntilSticky>
              <AnchorNav.Link href="#features">Features</AnchorNav.Link>
              <AnchorNav.Link href="#pricing">Pricing</AnchorNav.Link>

              <AnchorNav.Action href={extURLs.get_started}>Get started</AnchorNav.Action>
              <AnchorNav.Action href={extURLs.how_gh_works}>How GitHub works</AnchorNav.Action>
            </AnchorNav>
          </Box>

          <Spacer size="40px" size1012="80px" />

          <RiverBreakout className="fp-RiverBreakout">
            <RiverBreakout.A11yHeading>TODO</RiverBreakout.A11yHeading>
            <RiverBreakout.Visual>
              <Image
                className="fp-RiverBreakoutVisualImage"
                src="/images/modules/site/code-review/fp24/hero.webp"
                alt="TODO"
              />
            </RiverBreakout.Visual>
            <RiverBreakout.Content
              trailingComponent={() => (
                <Timeline>
                  <Timeline.Item>
                    Start a new feature or propose a change to existing code with a pull request—a base for your team to
                    coordinate details and refine your changes.
                  </Timeline.Item>
                  <Timeline.Item>
                    Pull requests are fundamental to how teams review and improve code on GitHub. Evolve projects,
                    propose new features, and discuss implementation details before changing your source code.
                  </Timeline.Item>
                </Timeline>
              )}
            >
              <Text>
                <em>Every change starts with a pull request.</em>
              </Text>
              <Link
                size="large"
                href="https://docs.github.com/pull-requests/collaborating-with-pull-requests/proposing-changes-to-your-work-with-pull-requests/about-pull-requests"
              >
                Learn pull request fundementals
              </Link>
            </RiverBreakout.Content>
          </RiverBreakout>
        </div>
      </section>

      <Spacer size="64px" size1012="128px" />
    </ThemeProvider>
  )
}

try{ CodeReviewIndex.displayName ||= 'CodeReviewIndex' } catch {}